// Match all non-Word symbols and replace with a dash — shared by TOC components and getTableOfContentsProps.
export const stringToLink = (heading: string) =>
    heading
        .toLowerCase()
        .trim()
        .replace(/[\W_^-]+/g, '-');
